/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
    production: false,
    apiUrl: 'https://qa.mindconnectapi.ss2.cware.co.za/api',
    appUrl: 'https://qa.mindconnect.ss2.cware.co.za'
};